import { render, staticRenderFns } from "./netvideo.vue?vue&type=template&id=40f91c1c"
import script from "./netvideo.vue?vue&type=script&lang=js"
export * from "./netvideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports